

























































































































import Tooltip from '@/components/tooltip/Tooltip.vue';
import { EStreamerType } from '@/api/schema';
import * as vr from '@/helpers/validation';
import { PropType } from 'vue';

type TFormData = {
  nickname: string;
  operatorUserId: string;
  accessCode: string;
  type: EStreamerType;
  shortBio: string;
  login: string;
  password: string;
  language: string;
};

export default {
  name: 'CopyStakeWebAiStreamerProfileForm',
  components: { Tooltip },
  props: {
    value: {
      type: Object as PropType<TFormData>,
      required: true
    },
    serverError: {
      type: Object,
      default: (): any => {
        return {};
      }
    },
    languages: {
      type: Array,
      default: (): any => {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data(): any {
    return {
      showPassword: true,
      formValid: false,
      streamerTypes: [
        { value: EStreamerType.PRIVATE, label: 'Private' },
        { value: EStreamerType.PUBLIC, label: 'Public' }
      ]
    };
  },
  computed: {
    formData: {
      get(): any {
        return this.value;
      },
      set(val: TFormData): void {
        this.$emit('input', val);
      }
    },
    rules(): any {
      return {
        nickname: [
          vr.required,
          (v: string) => vr.maxLength(v, 20),
          (v: string) =>
            vr.validByRegExp(
              v,
              /^[A-Za-z0-9\s_.-]{2,20}$/,
              'Only latin letters...'
            )
        ],
        operatorUserId: [vr.required],
        accessCode: [
          (v: string) =>
            this.formData.type === EStreamerType.PRIVATE
              ? vr.required(v)
              : true,
          (v: string) => !v || !v.includes(' ') || 'No blank space available',
          (v: string) =>
            !v ||
            vr.validByRegExp(
              v,
              /^[0-9A-Z]{6}$/i,
              'Must contains only numbers and A-Z'
            ),
          (v: string) => !v || vr.minLength(v, 6),
          (v: string) => !v || vr.maxLength(v, 6)
        ],
        type: [vr.required],
        shortBio: [(v: string) => !v || vr.maxLength(v, 140)],
        language: [vr.required],
        login: [(v: string) => vr.required(v, 'Login')],
        password: [(v: string) => vr.required(v, 'Password')]
      };
    }
  },
  methods: {
    validate(): void {
      return (this.$refs.form as any).validate();
    },
    reset(): void {
      return (this.$refs.form as any).reset();
    },
    async handlerOnSubmit(): Promise<void> {
      await this.$refs.form.validate();

      if (this.formValid) {
        this.$emit('submit');
      }
    }
  }
};
